const About = {
    sub: "O nas",
    heading: "Historia zabytkowego zespołu dworsko-parkowego w Imielnie",
    description: "Zespół dworsko-parkowy w Imielnie to jedno z najcenniejszych świadectw historii ziemi kutnowskiej. Naszą misją jest ochrona, dokumentowanie i przywracanie świetności temu wyjątkowemu miejscu, aby ponownie stało się przestrzenią kultury, edukacji oraz dialogu z przeszłością.",
    experience: {
        years: 1810,
        text: "rok powstania pierwszego dworu"
    },
    points: [
        'Unikatowy układ przestrzenny i murowany dwór z ok. 1850 r.',
        'Zabytkowy park z cennym starodrzewem',
        'Bogate dziedzictwo kulturowe ziemi kutnowskiej',
        'Potencjał rewitalizacji i ochrony pamięci regionu'
    ],
    button: {
        text: "Dowiedz się więcej",
        link: 'Historia'
    },

    presidentLetter: {
        title: "List Prezesa Fundacji Dwór Imielno",
        content: [
            "Są miejsca, które czekają. Nie na remont, nie na projekt, nie na pieniądze. Czekają na uważność.",
            "Dwór w Imielnie jest właśnie takim miejscem. Przez lata milczał, przykryty czasem, zapomnieniem i pośpiechem świata. A jednak nigdy nie przestał być obecny. W ziemi, w starych drzewach, w układzie przestrzeni, który pamięta więcej niż my sami.",
            "Fundacja Dwór Imielno powstała z potrzeby serca – z przekonania, że nie wszystko, co cenne, powinno być odbudowywane w pośpiechu, a nie wszystko, co stare, wymaga poprawiania. Czasem wystarczy wsłuchać się w miejsce i pozwolić mu znów oddychać.",
            "Wierzymy, że dziedzictwo to nie tylko mury. To także ogród. Rytm pór roku. Powtarzalność kwitnienia. Cisza, która koi. Historia zapisana w roślinach i krajobrazie. Dlatego w Imielnie odbudowujemy relację między dworem a ogrodem – nie jako dekorację, lecz jako żywą opowieść.",
            "Ogród cebulowy, który tu powstaje, jest dla nas symbolem. Cebula znika pod ziemią. Czeka. Pracuje w ciszy. By w odpowiednim momencie powrócić z siłą i pięknem. Tak samo rozumiemy pamięć, kulturę i tożsamość miejsca. Nie krzyczą. One dojrzewają.",
            "Fundacja Dwór Imielno to przestrzeń spotkania – człowieka z naturą, przeszłości z teraźniejszością, wiedzy z emocją. Chcemy, by Imielno było miejscem, w którym można się zatrzymać, pomyśleć, poczuć i przypomnieć sobie, że piękno nie musi być szybkie, a sens nie zawsze jest głośny.",
            "Zapraszam Państwa do tej drogi. Do wspólnego przywracania znaczeń. Do uważnego bycia w miejscu, które znów chce opowiadać swoją historię."
        ],
        closing: "Z szacunkiem i odpowiedzialnością",
        signature: "mgr inż. Mariusz Gądziak",
        role: "Prezes Fundacji Dwór Imielno"
    },
    manifest: {
        title: "MANIFEST FUNDACJI DWÓR IMIELNO",
        subtitle: "Nie odbudowujemy ruin. Odbudowujemy relacje.",
        beliefs: [
            "dziedzictwo żyje tylko wtedy, gdy jest doświadczane",
            "ogród jest równoprawnym świadkiem historii",
            "natura nie jest tłem, lecz partnerem",
            "mniej pośpiechu oznacza więcej sensu",
            "pamięć potrzebuje troski, nie rekonstrukcji na pokaz"
        ],
        conclusion: [
            "Dwór Imielno to nie projekt.",
            "To proces.",
            "To odpowiedzialność.",
            "To powrót do uważności."
        ]
    }
}

export default About;